{
  "nps": {
    "question": "How likely are you to recommend Cycling Zone to a friend?",
    "scaleLow": "Not likely",
    "scaleHigh": "Very likely",
    "reasonLabel": "What's the main reason? (optional)",
    "reasonPlaceholder": "Optional: the main reason, in a sentence or two",
    "submit": "Send",
    "notNow": "Not now",
    "thanks": "Thanks. That tells me what to work on next.",
    "regionAriaLabel": "Feedback prompt",
    "dismissAriaLabel": "Dismiss feedback prompt"
  },
  "consent": {
    "title": "I use data to make the game better",
    "intro": "You decide what I may measure. You can always change your choices in your profile under \"Privacy\".",
    "privacyLink": "Read the privacy policy",
    "closeAriaLabel": "Close without changing",
    "alwaysOn": "(always on)",
    "save": "Save my choices",
    "customize": "Customize",
    "rejectAll": "Necessary only",
    "acceptAll": "Accept all",
    "categories": {
      "necessary": {
        "label": "Necessary",
        "desc": "Login, session and your account settings. The game does not work without these."
      },
      "analytics": {
        "label": "Analytics",
        "desc": "I anonymously measure how the game is used: which buttons frustrate players (Microsoft Clarity), where players come from (Google Analytics) and page views (Vercel Web Analytics), so I can fix bad UX. PostHog counts page views and key steps in the game without cookies and links them to your account ID once you log in. Rejecting analytics turns PostHog off too."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Not used today. If I later show ads or remarket, it only happens if you say yes here."
      },
      "email_marketing": {
        "label": "Email",
        "desc": "Occasional newsletters about major season updates or events. Transactional emails (auction won, etc.) do not depend on this choice."
      }
    }
  },
  "releaseUpdate": {
    "title": "New version ready",
    "action": "Update",
    "regionAriaLabel": "Update available",
    "unsavedTitle": "You have unsaved changes. Save first, or update anyway.",
    "saveFirst": "Save first",
    "updateAnyway": "Update anyway"
  },
  "opsNotice": {
    "regionAriaLabel": "Service status",
    "dismissAriaLabel": "Dismiss notice",
    "knownIssuesLink": "Known issues"
  },
  "racePaused": {
    "title": "Paused.",
    "newStart": "New start {time}.",
    "newStartUnknown": "New start time will be announced."
  },
  "racePauseInfoBar": {
    "regionAriaLabel": "Race status",
    "title": "Races are paused.",
    "newStart": "New start {time}.",
    "newStartUnknown": "I will announce the new start time here."
  }
}
